import { render, staticRenderFns } from "./LiveNotificationToasts.vue?vue&type=template&id=1208f82f&scoped=true&"
import script from "./LiveNotificationToasts.vue?vue&type=script&lang=js&"
export * from "./LiveNotificationToasts.vue?vue&type=script&lang=js&"
import style0 from "./LiveNotificationToasts.vue?vue&type=style&index=0&id=1208f82f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1208f82f",
  null
  
)

export default component.exports